module.exports = __webpack_public_path__ + "35f868db9eaf7cf1c33ed1d5b939cb85.png";